const btnScroll = jQuery('.btn-scroll');

// On scroll - Show 'Scroll To Top' Button
jQuery(window).scroll(handleScrollBtnVisibility);

btnScroll.click(scrollToTop);

function handleScrollBtnVisibility() {
    if(document.documentElement.scrollTop || document.body.scrollTop > window.innerHeight) {
        btnScroll.addClass('btn-scroll--active');
        return;
    }
    
    btnScroll.removeClass('btn-scroll--active');
}

// Scroll To Top - Action
function scrollToTop() {
    jQuery('html, body').animate({scrollTop : 0},700);
}